import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { AppView, Table } from 'medua-components';
import { history } from '../../../../store';

/* eslint-disable */
@translate('account')
export default class AccountBillingHistory extends Component {

  constructor(props) {
    super(props);
    this.state = {
      toggle: '',
    };

    this.handleBack = this.handleBack.bind(this)
  }

  handleBack() {
    history.push('/account/billing')
  }

  render() {
    return (
      <AppView
        color="dark"
        title={ this.props.t('account:billing.history.title') }
        headerActionLeft={[
          { key: 1, icon: 'arrow-left', action: this.handleBack }
        ]}>
      </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/billing/history/index.jsx